import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
  color: var(--p-text-color);
}

.label {
  display: block;
  word-break: break-word;
  font-size: var(--p-label-font-size, .9rem);
  line-height: var(--p-label-line-height, 1.3);
  font-weight: var(--p-label-font-weight, bold);
  color: var(--p-text-color);
}

.label span {
  color: var(--p-error);
}

.usage-types-wrap {
  display: grid;
  grid-template-columns: var(--p-label-left-grid, 30% 70%);
}

.usage-types-wrap div[role="group"] {
  --p-input-margin-bottom: 10px;
  padding-left: 10px;
}

.error-message {
  color: var(--p-error);
  font-size: var(--p-error-font-size, .875rem);
  line-height: var(--p-error-line-height, 1.3);
  margin-bottom: 15px;
}

`;
